import { BaseModalInterface } from './base-modal.interface';

export interface InfoModalInterface extends BaseModalInterface {
  markdown: string;
  showTicket: boolean;
}
